import { PropsWithChildren } from "react"
import { NavLink as ReactRouterNavLink } from "react-router-dom"
import classNames from "classnames"

interface Props extends PropsWithChildren {
  to: string
  className?: string
  activeClassName?: string
  end?: boolean
  onClick?: () => void
}

export const NavLink = ({ to, className, activeClassName, children, onClick, end }: Props) => {
  return (
    <ReactRouterNavLink
      to={to}
      end={end}
      onClick={onClick}
      className={navData => classNames(className, `${navData.isActive && activeClassName}`)}
    >
      {children}
    </ReactRouterNavLink>
  )
}
